/* Progressive enhancement for native field-guide disclosures. */
(function () {
  'use strict';
  function initialize(root) {
    if (!root || root.dataset.ggEditorialReady) return;
    root.dataset.ggEditorialReady = 'true';
    function reveal(hash, shouldFocus) {
      if (!hash || hash.charAt(0) !== '#') return;
      var id;
      try { id = decodeURIComponent(hash.slice(1)); } catch (error) { return; }
      var target = document.getElementById(id);
      if (!target || !root.contains(target)) return;
      var disclosure = target.closest('details');
      while (disclosure && root.contains(disclosure)) {
        disclosure.open = true;
        disclosure = disclosure.parentElement.closest('details');
      }
      if (shouldFocus) {
        var focusTarget = target.matches('details') ? target.querySelector('summary') : target.querySelector('h2, h3') || target;
        if (!focusTarget.matches('summary, a, button, input')) focusTarget.setAttribute('tabindex', '-1');
        focusTarget.focus({preventScroll:true});
        target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
      }
      return true;
    }
    root.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link || !root.contains(link) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var hash = link.getAttribute('href');
      if (reveal(hash, true)) {
        event.preventDefault();
        if (window.location.hash !== hash) window.history.pushState(null, '', hash);
      }
    });
    window.addEventListener('hashchange', function () { reveal(window.location.hash, false); });
    reveal(window.location.hash, false);
  }
  function initializeComparison(region) {
    if (region.dataset.ggComparisonReady) return;
    region.dataset.ggComparisonReady = 'true';
    // WebKit does not consistently scroll a focused overflow region with arrow keys.
    region.addEventListener('keydown', function (event) {
      if (event.target !== region || document.activeElement !== region || event.defaultPrevented || event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
      var maximum = region.scrollWidth - region.clientWidth;
      if (maximum <= 1) return;
      var next;
      if (event.key === 'ArrowRight') next = region.scrollLeft + region.clientWidth / 2;
      else if (event.key === 'ArrowLeft') next = region.scrollLeft - region.clientWidth / 2;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = maximum;
      else return;
      event.preventDefault();
      region.scrollTo({left:Math.max(0, Math.min(maximum, next)), behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    });
  }
  function initializeAll(scope) {
    if (scope.matches && scope.matches('[data-gg-editorial]')) initialize(scope);
    scope.querySelectorAll('[data-gg-editorial]').forEach(initialize);
    if (scope.matches && scope.matches('.gg-ms-compare-scroll')) initializeComparison(scope);
    scope.querySelectorAll('.gg-ms-compare-scroll').forEach(initializeComparison);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  else initializeAll(document);
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
}());
